define(
    'viewmodels/secured/libraries/settings/folder/library',[
        "providers/dataprovider",
        "i19n!i19n/strings",
    ],
    function (dataProvider, i19n) {

        function Library(id, templateId, name, FolderActions, _folderSelected) {
            var self = this;

            self._loadTreePromise = null;

            self.i19n = i19n;
            self.id = id;
            self.name = name;
            self.initialized = ko.observable(false);
            self.folders = ko.observableArray();
            self.loadingFolders = ko.observable();
            self.folderActions = new FolderActions(id); //treenode supplied by widget treeview
            self.folderActions.isTemplate = true;
            self.treeData = {
                id: 'library-tree-' + id,
                node: {
                    add: {},
                    rename: {},
                    remove: {},
                    select: function (n) {
                        _folderSelected(n);
                    },
                },
                isShowAllVisible: false,
                deselect: {},
                folderActions: self.folderActions,
                collapseExpand: {},
                loadBegin: {},
                getTreeviewDataSource: function (complete) {
                    return new kendo.data.HierarchicalDataSource({
                        transport: {
                            read: function (callbacks) {
                                callbacks.success([]);

                                if (self._loadTreePromise) {
                                    self.treeData.loadBegin();

                                    ////self.treeData.getDataSource().read();

                                    //dataProvider
                                    //.libraries
                                    //.getSettings(self.id)
                                    //.done(function (folders) {
                                    //    var templateId = folders.libraryTemplates[0].id;
                                        ////currently the libraryTemplates does not format the relationship correctly
                                        ////so we are callign the flatlist instead and format them
                                        ////
                                        ////folders = mapFolders(folders.libraryTemplates);
                                        ////setTimeout(function () {
                                        ////    callbacks.success(folders);
                                        ////}, 500);

                                        ////folders = mapFolders(folders.libraryTemplates);
                                        ////callbacks.success(folders);
                                        ////console.warn(folders);
                                        ////return;

                                        dataProvider
                                        .templatefolders
                                        .getFolders(templateId)
                                        .done(function (data) {
                                            var root = [{ id: templateId, text: data.name, expanded: true, items: [] }];
                                            var list = _.map(data.templateFolders, function (itm) {
                                                return {
                                                    id: itm.id,
                                                    templateId: itm.templateId,
                                                    parentId: itm.parentId,
                                                    text: itm.name,
                                                    expanded: false,
                                                    docCount: 0,
                                                    items: []
                                                };
                                            });

                                            //list = _.sortBy(list, function (itm) { return itm.text; });
                                            list.sort(function (a, b) {
                                                if (!a.text || !b.text)
                                                    return -1;

                                                var an = padNumbers(a.text.toLowerCase()),
                                                    bn = padNumbers(b.text.toLowerCase());

                                                return an > bn ? 1 : -1;
                                            });

                                            root[0].items = listToTree(list);

                                            callbacks.success(root);

                                            self.initialized(true);
                                            self.loadingFolders(false);
                                            self._loadTreePromise.resolve(root);
                                        })
                                        .fail(function (e) {
                                            self.initialized(true);
                                            self.loadingFolders(false);

                                            self._loadTreePromise.resolve([]);

                                            console.error(e);
                                        })
                                        .always(complete);
                                    //})
                                    //.fail(function (e) {
                                    //    console.error(e);
                                    //});
                                }
                            }
                        },
                        schema: {
                            model: {
                                id: "id",
                                hasChildren: "hasChildren",
                                children: "items"
                            }
                        },
                    });
                }
            };
        }

        Library.prototype.loadTree = function () {
            var self = this;

            self._loadTreePromise = $.Deferred();

            self.loadingFolders(true);
            
            if(self.initialized()){
                //self.treeData.loadBegin();
                self.treeData.getDataSource().read();
            }

            return self._loadTreePromise.promise();
        };

        return Library;

        function listToTree(list) {
            var id = "id";
            var parent = "parentId";
            var children = "items";
            var tree = [];
            var lookup = {};
            
            list.forEach(function (o) {
                lookup[o[id]] = o;
                o[children] = [];
            });
            list.forEach(function (o) {
                if (o[parent] != null) {
                    lookup[o[parent]][children].push(o);
                } else {
                    tree.push(o);
                }
            });

            return tree;
        }

        function mapFolders(folders, expanded) {
            //folders = _.sortBy(folders, function (itm) { return itm.name; });
            folders.sort(function (a, b) {
                if (!a.name || !b.name)
                    return -1;
                var an = padNumbers(a.name.toLowerCase()),
                    bn = padNumbers(b.name.toLowerCase());

                return an > bn ? 1 : -1;
            });

            return _.map(folders, function (itm) {
                var hasChildren = itm.folders ? (itm.folders.length > 0 ? true : false) : false;
                
                return {
                    id: itm.id,
                    templateId: itm.templateId,
                    parentId: itm.parentId,
                    text: itm.name,
                    expanded: expanded === undefined,
                    hasChildren: hasChildren,
                    docCount: itm.documentCount,
                    items: itm.folders ? mapFolders(itm.folders, false) : [],
                    data: itm
                };
            });
        }
        function padNumbers(string, length) {
            if (!length) {
                length = 10;
            }

            return string.replace(/(\d+(\S\d+)*)/g, function (m) {
                var delimiter, decimalLength;

                //// preserve decimal delimiter
                //m = m.replace(/(\D)(\d+)$/, function (m, delim, num) {
                //    delimiter = delim;
                //    decimalLength = num.length;

                //    return '###' + num;
                //});
                //for (var i = 0; i < 10; i++) {
                m = m.replace(".", "###");
                //}

                // if decimal delimiter occurs multiple times
                // it is not a decimal delimiter, but thousand delimiter
                if (delimiter && m.indexOf(delimiter) > -1) {
                    m = m.replace('###', '');
                } else {

                    // TODO: what to do with decimals that 
                    // are 3-accurate - could be german thousand-delimiter
                }

                // remove thousand delimiters
                m = m.replace(/[^0-9#]/g, '');

                // left-padd integer
                m = m.replace(/^\d+/, function (m) {
                    while (m.length < length) {
                        m = "0" + m;
                    }

                    return m;
                });

                // add decimal component
                if (m.indexOf('#') < 0) {
                    m += "###0";
                }

                // right-padd decimal
                m = m.replace(/#(\d+)$/, function (tmp, m) {
                    while (m.length < length) {
                        m += "0";
                    }

                    return m;
                });

                return m;
            });
        }
    });
